import React, { Component, Suspense } from 'react';
import search from "../images/icons/Search.png"
// import SearchPulldown from "../headerComponents/search"
// import ResataurantSearchPulldown from "../headerComponents/restaurantSearch"
// import CommonItemSearchPulldown from "../headerComponents/commonItemSearch"
import searchico from "../images/lokal/search.png"
import { elasticLink, elasticHostURL } from "../config";
 import $ from "jquery";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
let SearchPulldown = React.lazy(() => import("../headerComponents/search"))
let ResataurantSearchPulldown = React.lazy(() => import("../headerComponents/restaurantSearch"))
let CommonItemSearchPulldown = React.lazy(() => import("../headerComponents/commonItemSearch"))
const AWS = require('aws-sdk');
const elasticsearch = require("elasticsearch");
AWS.config.region = 'us-west-1';
export default class HeaderSearch extends Component {
    constructor(props) {
        super(props)
        this.state = {
            searchResultData: []
        };
    }
    async search(keyWord) {
        const client = new elasticsearch.Client({
            host: elasticHostURL(),
            amazonES: {
                region: 'us-west-1',
                // credentials: new AWS.Credentials(this.state.s3AccessKey, this.state.s3SecretKey)
            }
        });
        let storeId = window.sessionStorage.getItem('storeId');
        const body = await client.search({
            index: elasticLink() + '-autocomplete-loose',
            from: 0, size: 20,
            body: {
                query:
                {
                    bool: {
                        "must": {
                            "multi_match": {
                                "query": keyWord,
                                "type": "phrase_prefix",
                                "fields": ["search_item_name", "category_group_name"]
                            }
                        },
                        filter:
                        {
                            bool:
                            {
                                must: [{
                                    terms: {
                                        store_id: [storeId]
                                    }
                                }
                                ]
                            }
                        }
                    }
                }
            }
        });
        if (body.hits.hits.length > 0) {
            $(".cartButtonSearchHome").removeClass("cart_clk")
            $(".cartInputSearchHome").val(1)
            $(".searchList").removeClass("addcartActive")
            $(".headerSearchSubOuter").show();
            $(".addToCartImg").hide();
            this.setState({
                searchResultData: body.hits.hits
            });
        }
        else {
            $(".headerSearchSubOuter").hide();
        }
    }
    async restaurantSearch(keyWord) {
        const client = new elasticsearch.Client({
            host: elasticHostURL(),
            amazonES: {
                region: 'us-west-1',
                // credentials: new AWS.Credentials(this.state.s3AccessKey, this.state.s3SecretKey)
            }
        });
        let storeId = window.sessionStorage.getItem('storeId');
        const body = await client.search({
            index: elasticLink() + '-rt-search',
            from: 0, size: 20,
            body: {
                query:
                {
                    bool: {
                        "must": {
                            "multi_match": {
                                "query": keyWord,
                                "type": "phrase_prefix",
                                "fields": ["searchstring"]
                            }
                        },
                        filter:
                        {
                            bool:
                            {
                                must: [{
                                    terms: {
                                        storeid: [storeId]
                                    }
                                }
                                ]
                            }
                        }
                    }
                }
            }
        });
        if (body.hits.hits.length > 0) {
            $(".searchList").removeClass("addcartActive")
            $(".headerSearchSubOuter").show();
            this.setState({
                searchResultData: body.hits.hits
            });
        }
        else {
            $(".headerSearchSubOuter").hide();
        }
    }
    async commonItemSearch(keyWord) {
        const client = new elasticsearch.Client({
            host: elasticHostURL(),
            amazonES: {
                region: 'us-west-1',
                // credentials: new AWS.Credentials(this.state.s3AccessKey, this.state.s3SecretKey)
            }
        });
        let storeId = window.sessionStorage.getItem('storeId');
        const body = await client.search({
            index: elasticLink() + '-cm-commonitem-search',
            from: 0, size: 20,
            body: {
                query:
                {
                    bool: {
                        "must": {
                            "multi_match": {
                                "query": keyWord,
                                "type": "phrase_prefix",
                                "fields": ["search_string"]
                            }
                        },
                        filter:
                        {
                            bool:
                            {
                                must: [{
                                    terms: {
                                        store_id: [storeId]
                                    }
                                }
                                ]
                            }
                        }
                    }
                }
            }
        });
        if (body.hits.hits.length > 0) {
            $(".searchList").removeClass("addcartActive")
            $(".headerSearchSubOuter").show();
            this.setState({
                searchResultData: body.hits.hits
            });
        }
        else {
            $(".headerSearchSubOuter").hide();
        }
    }
    searchSolarDetails() {
        var keyWord = $('#txtSearch').val()
        if (keyWord !== '' && keyWord.length > 2) {

            let mainGroupCategory = window.sessionStorage.getItem('mainGroupCategory');
            if (keyWord !== '') {
                if (mainGroupCategory === '1') {
                    this.search(keyWord);
                }
                else if (mainGroupCategory === '5') {
                    this.restaurantSearch(keyWord);
                }
                else if (mainGroupCategory === '8') {
                    this.commonItemSearch(keyWord);
                }
            }
            else {
                this.setState({
                    searchResultData: []
                });
            }
        }
        else {
            $(".headerSearchSubOuter").hide();
        }
    }
    viewMoreClick() {
        var searchKeyword = $("#txtSearch").val()
        var mainCategoryId = window.sessionStorage.getItem('mainGroupCategory')
        if (searchKeyword !== null && searchKeyword !== '' && searchKeyword.length > 2) {
            if (mainCategoryId === '1') {
                window.location.href = `${process.env.PUBLIC_URL}/listing/2/5/0/${searchKeyword}`
            }
            else if (mainCategoryId === '5') {
                window.location.href = `${process.env.PUBLIC_URL}/restaurantListing/0/0/${searchKeyword}`
            }
            else {
                window.location.href = `${process.env.PUBLIC_URL}/cmItemListing/0/0/0/${searchKeyword}`
            }
        }
        else {
            $("#txtSearch").focus()
        }
    }
    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if ($("#txtSearch").val() !== "" && $("#txtSearch").val().length > 2) {
                this.viewMoreClick()
            }
        }
    }
    render() {
        let siteCategoryId = window.sessionStorage.getItem('siteCategoryId')
        let storeId = window.sessionStorage.getItem('storeId')
        let themeId = localStorage.getItem('themeId')
        let isHeaderIconHide = '0'
        var siteUrlHeader = window.location.href;
        var siteUrlPathname = window.location.pathname;
        if (siteUrlHeader.indexOf("OrderSummary") !== -1 || siteUrlHeader.indexOf("viewOrder") !== -1) {
            isHeaderIconHide = '1'
        }
        var subDomainFlag = window.sessionStorage.getItem('subDomainFlag');
        return (
            (() => {
                if ((siteUrlPathname === "/" || siteUrlPathname === "/category" || siteUrlPathname === "/store" || siteUrlPathname === "/globalSearchResult") && isHeaderIconHide === '0' && siteCategoryId !== "0" && subDomainFlag !== "1") {
                    return (
                        <div></div>
                    )
                }
                else if (storeId !== null && storeId !== 'null' && storeId !== '' && isHeaderIconHide === '0' && siteCategoryId !== "0") {
                    return (
                        <div className="headerIcons search">
                            <Suspense fallback={<div></div>}>

                                <div className="headerSearch">
                                    <div className="searchField">
                                        <input type="text" autoComplete="off" placeholder="Search your product" id="txtSearch" name="txtSearch" onKeyDown={this._handleKeyDown} onKeyUp={(e) => this.searchSolarDetails()} />
                                        <span className="searchBtn" onClick={(e) => this.viewMoreClick()} ><img src={searchico} alt="" /></span>
                                    </div>
                                    {(this.state.searchResultData.length > 0 && window.sessionStorage.getItem('mainGroupCategory') === '5') ?
                                        <ResataurantSearchPulldown viewMoreClick={this.viewMoreClick} searchResultData={this.state.searchResultData} itemImagePath={this.state.restaurantItemImagePath} ></ResataurantSearchPulldown>
                                        :
                                        (this.state.searchResultData.length > 0 && window.sessionStorage.getItem('mainGroupCategory') === '8') ?
                                            <CommonItemSearchPulldown viewMoreClick={this.viewMoreClick} searchResultData={this.state.searchResultData} itemImagePath={this.state.cmImagePath} ></CommonItemSearchPulldown>
                                            :
                                            (this.state.searchResultData.length > 0) ?
                                                <SearchPulldown viewMoreClick={this.viewMoreClick} searchResultData={this.state.searchResultData} itemImagePath={this.state.itemImagePath}></SearchPulldown>
                                                :
                                                ''
                                    }
                                    <div className="mobileSearch" ><img src={search} alt="" /></div>
                                </div>
                            </Suspense>
                        </div>
                    )
                }
                else if (siteCategoryId === "0" && isHeaderIconHide === '0') {
                    return (
                        <div className={(themeId === "36" || themeId === "35") ? "headerSearch" : ""}>
                            <Suspense fallback={<div></div>}>

                                {(() => {
                                    if (themeId === "36" || themeId === "35") {
                                        return (
                                            <div className="searchField">
                                                <input type="text" autoComplete="off" placeholder="What Are You Looking For ?" id="txtSearch" name="txtSearch" onKeyDown={this._handleKeyDown} onKeyUp={(e) => this.searchSolarDetails()} />
                                                <span className="searchBtn" onClick={(e) => this.viewMoreClick()} ><FontAwesomeIcon icon={faSearch} /></span>
                                            </div>
                                        )
                                    }
                                    else {
                                        return (
                                            <div className="searchField">
                                                <input type="text" autoComplete="off" placeholder="What Are You Looking For ?" id="txtSearch" name="txtSearch" onKeyDown={this._handleKeyDown} onKeyUp={(e) => this.searchSolarDetails()} />
                                                <img src={search} alt="" onClick={(e) => this.viewMoreClick()} />
                                            </div>
                                        )
                                    }
                                })()}
                                {(this.state.searchResultData.length > 0 && window.sessionStorage.getItem('mainGroupCategory') === '5') ?
                                    <ResataurantSearchPulldown viewMoreClick={this.viewMoreClick} searchResultData={this.state.searchResultData} itemImagePath={this.state.restaurantItemImagePath} ></ResataurantSearchPulldown>
                                    :
                                    (this.state.searchResultData.length > 0 && window.sessionStorage.getItem('mainGroupCategory') === '8') ?
                                        <CommonItemSearchPulldown viewMoreClick={this.viewMoreClick} searchResultData={this.state.searchResultData} itemImagePath={this.state.cmImagePath} ></CommonItemSearchPulldown>
                                        :
                                        (this.state.searchResultData.length > 0) ?
                                            <SearchPulldown viewMoreClick={this.viewMoreClick} searchResultData={this.state.searchResultData} itemImagePath={this.state.itemImagePath}></SearchPulldown>
                                            :
                                            ''
                                }
                                <div className="mobileSearch"><img src={search} alt="" /></div>
                            </Suspense>
                        </div>
                    )
                }
                else {
                    return ('')
                }
            })()
        )
    }
}